// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'
// Import the loadRecaptchaDelayed script
import './loadRecaptchaDelayed.js'

// wait for dom to load
document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM loaded');
});
